import { registerModal } from 'features/Modal/ModalRegistry'
import { showModal } from 'features/Modal/Modal.actions'

import ConfirmationCodeFormModal from './ConfirmationCodeFormModal'

export const modalType = 'CONFIRMATION_CODE_FORM_MODAL'
registerModal(modalType, ConfirmationCodeFormModal)

export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ConfirmationCodeFormModal/ConfirmationCodeFormModal.action.js